import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../actions/consumer.actions";
import { VendorActions } from "../actions/vendor.actions";
import { DailyStatsState } from "../models/shared/daily-stats-state";

const initialState: DailyStatsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.dailyStats.getApi, (state) => _.set(_.cloneDeep(state), "loading", true)),
	on(ConsumerActions.dailyStats.getSuccess, (state, action) => _.omit(action, "type")),
	on(VendorActions.dailyStats.getApi, (state) => _.set(_.cloneDeep(state), "loading", true)),
	on(VendorActions.dailyStats.getSuccess, (state, action) => _.omit(action, "type"))
);

export function dailyStatsReducer(
	state: DailyStatsState | undefined,
	action: Action
): DailyStatsState {
	return reducer(state, action);
}
